import type { ILocalePreferences } from '@featit/shared/i18n/core';
import { languagePreference } from './languageInstance';

/**
 * I-1971: the person's language and region as their session carries them (`/auth/me` and the sign-in
 * answers, `localePreferences`), adopted at once, so the page draws them in it from the first screen. A
 * device with no cached copy — a new one, or one whose sign-out dropped it (owner rule) — otherwise drew
 * the browser's language until `LanguageSync` had read the setting after the launch.
 *
 * A saved language only: `null` ("follow my browser") leaves this device's cached choice for
 * `LanguageSync`, which makes a choice made here before an account the account's. `LanguageSync` stays
 * the one that saves a choice.
 */
export function adoptSessionLanguage(preferences: ILocalePreferences | undefined): void {
  if (!preferences) return;
  const { choice, region } = languagePreference.getSnapshot();
  if (preferences.locale !== null && preferences.locale !== choice) {
    languagePreference.adopt(preferences.locale);
  }
  if (preferences.region !== null && preferences.region !== region) {
    languagePreference.adoptRegion(preferences.region);
  }
}
